<template>
  <div class="flex" :class="direction === 'row' ? 'space-x-2' : 'space-y-2 flex-col'">
    <button :class="minimal ? 'min-w-12' : ''" class="btn btn--sm btn--blue" @click="copyImage(url)">
      <i class="fa-regular fa-copy"></i>
      <span v-if="!minimal">Copy image</span>
    </button>
    <button
      :class="minimal ? 'min-w-12' : ''"
      class="btn btn--sm btn--secondary"
      @click="copy(url, 'Copied image link')"
    >
      <i class="fa-solid fa-link"></i>
      <span v-if="!minimal">Copy link</span>
    </button>
  </div>
</template>

<script setup lang="ts">
  import { copyImage, copy } from '$/utils'

  withDefaults(
    defineProps<{
      url: string
      direction?: string
      minimal?: boolean
    }>(),
    {
      direction: 'row',
      minimal: false,
    },
  )
</script>
